import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"; // Import necessary components

import "./App.css";
// All Components
import Header from "./components/Header/header";
import NotFound from "./components/404Page/NotFound";
import Footer from "./components/Footer/footer";
import ScrollToTopButton from "./components/ScrollToTop/ScrollToTopButton";
import ContactUs from "./components/Contact/ContactUs";

// Home
import VårJobb from "./Home/OurSolution/OurSolution";
import VideoFrameOne from "./Home/VideoFrameOne/VideoFrameOne";
import Partnerskap from "./Home/Partnerskap/Partnerskap";
import Trygghet from "./Home/Trygghet/Trygghet";
import Licensiering from "./Home/Licensiering/Licensiering";
import KomplettService from "./Home/KomplettService/KomplettService";
import Arkitekttjänst from "./Home/Arkitekttjänst/Arkitekttjänst";
import FiveImagesLayout from "./Home/FiveImagesLayout/FiveImagesLayout";

// Tjänster
import TjänsterArbeteTakTillGolv from "./Tjänster/TjänsterArbete/TjänsterArbete";

// Få offert
import Offert from "./components/Offert/Offert";
import EnglishPage from "./EnglishPages/Box1Barton1/EnglishPage";
import LogoSlideshow from "./Home/LogoSlideshow/LogoSlideshow";

function App() {
  return (
    <Router basename="/">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tjänster" element={<TjänsterArbetes />} />
        <Route path="/kontakta-oss" element={<Contact />} />
        <Route path="/få-offert" element={<Offerts />} />
        <Route path="/en-us" element={<EnglishPages />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

function Home() {
  return (
    <>
      <Header />
      <VideoFrameOne />
      <VårJobb />
      <Partnerskap/>
      <LogoSlideshow />
      <Trygghet />
      <Licensiering />
      <KomplettService />
      <Arkitekttjänst />
      <FiveImagesLayout />
      <ScrollToTopButton />
      <Footer />
    </>
  );
}


function TjänsterArbetes() {
  return (
    <>
      <Header />
      <TjänsterArbeteTakTillGolv />
      <Footer />
    </>
  );
}

function EnglishPages() {
  return (
    <>
      <Header />
      <EnglishPage />
      <Footer />
    </>
  );
}
function Contact() {
  return (
    <>
      <Header />
      <ContactUs />
      <Footer />
    </>
  );
}

function Offerts() {
  return (
    <>
      <Header />
      <Offert />
      <Footer />
    </>
  );
}

function NotFoundPage() {
  return (
    <>
      <Header />
      <NotFound />
      <Footer />
    </>
  );
}

export default App;
